import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
import { VehicleState } from './vehicle-state.model';
import { Vehicle } from '../../admin/models/vehicles/vehicle';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class VehicleActions {
  /**
  * @var Declaration of the action to set the vin
  **/
  static readonly SET_VEHICLES = 'SET_VEHICLES';
  /**
  * @var Declaration of the action to reset vehicle store
  **/
  static readonly RESET_VEHICLESTORE = 'RESET_VEHICLESTORE';
    /**
  * @property Declaration of the action to set the remote details
  **/
     static readonly SET_REMOTE_DETAILS = 'SET_REMOTE_DETAILS';
  /**
  * setVin sets the brand of the vehicle
  * @param vin Value of the vin (T or L)
  **/
  static setVehicles(vehicles: Array<any>) {
    const vehicleInfo = {
      vehicles,
      remote: {
        remoteUserGuid: vehicles['remoteUserGuid'],
        remoteSubscriptionStatus: vehicles['remoteSubscriptionStatus']
      },
    };
    return {
      type: VehicleActions.SET_VEHICLES,
      payload: { vehicles: vehicleInfo }
    };
  }
  /**
   * resetVehicleStore sets the wifi
   **/
  static resetVehicleStore() {
    return {
      type: VehicleActions.RESET_VEHICLESTORE
    };
  }
    /**
  * @function setRemoteDetails set the remote details
  **/
     static setRemoteDetails(remoteDetails: object) {
      return {
        type: VehicleActions.SET_REMOTE_DETAILS,
        payload: remoteDetails
      };
    }
}
